class Particles {
    constructor(root) {
        this.root = root;
        this.scrollFactor = -2.0;

        this.bp = [
            {
                min: 0,
                max: 768,
                image: '/app/themes/cherrypulp/resources/images/medialed-d-background.jpg',
            },
            {
                min: 768,
                max: 1280,
                image: '/app/themes/cherrypulp/resources/images/medialed-d-background-md.jpg',
            },
            {
                min: 1280,
                max: Infinity,
                image: '/app/themes/cherrypulp/resources/images/medialed-d-background-xl.jpg',
            },
        ];

        this.setBg();

        this.bind();
    }

    bind() {
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        document.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
    }

    unbind() {
        document.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }

    onScroll() {
        this.root.style.backgroundPositionY = `${window.scrollY * this.scrollFactor}px`;
    }

    onResize() {
        this.setBg();
    }

    setBg() {
        const current = this.getCurrent();

        if (current === this.current) {
            return;
        }

        const { image } = this.bp[current];

        this.root.style.backgroundImage = `url('${image}')`;

        this.current = current;
    }

    getCurrent() {
        let c = 0;
        const { innerWidth } = window;

        this.bp.forEach((bp, index) => {
            if (innerWidth >= bp.min && innerWidth < bp.max) {
                c = index;
            }
        });

        return c;
    }

    destroy() {
        this.unbind();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-particles]').length > 0
    },

    mounted() {
        document.querySelectorAll('[data-particles]').forEach(particles => {
            new Particles(particles)
        })
    },
}
